import { UploadParams } from './types';

export abstract class FileUploader {

  abstract upload(file: File | Blob, option?: UploadParams): Promise<string>;

}
